import { useCallback, useEffect, useMemo, useRef, useState } from "react";

// import InfoPanelWithoutKeyValue from "../../ClientDashboard/shared/InfoPanelWithoutKeyValue";
import GenrateDocument from "../../GenrateDocument/GenrateDocument";
import TreatmentNotesSection from "../../TreatmentPage/NotesTreatmentSection";
import DocumentRow from "../../DocumentRow/DocumentRow";
import PanelActionBarComponent from "../../common/PanelActionBarComponent";
import ContactPanelForTreatment from "../../TreatmentPage/components/ContactPanelForTreatment";
import EditReportModal from "../ReportModals/EditReportModal";
import { api_without_cancellation } from "../../../api/api";
import ConfirmDeletePopup from "../ReportModals/ConfirmDeletePopup";
import InformationPanel from "../../common/InformationPanel";
import costIcon from "../../../../public/BP_resources/images/icon/costs-icon-color.svg";
import { PhotoSlot } from "../../../Modules/NewCasePage";
import DefaultThumbnail from "../../common/defaultPhotoSlot";
import CostRequestModal from "../../common/modals/CostRequestModal";
import { checkPendingCost } from "../../../Hooks/checkPendingCosts";
import { formatCalendarDate, currencyFormat, getCaseId, getClientId } from "../../../Utils/helper";
import "../../common/RecordPanel.css";

const ReportTab = ({ reports, fetchReports, isDummy }) => {
  const [selectedReport, setSelectedReport] = useState(null);
  const [forDeleteReportId, setForDeleteReportId] = useState(null);
  const [showDocument, setShowDocument] = useState(false);
  const [instanceIdForGenrateDoc, setInstanceIdForGenrateDoc] = useState(null);
  const [dropdownName, setDropdownName] = useState(null);
  const [showDeleteConfirm, setShowDeleteConfirm] = useState(false);
  const [costRequestModalProps, setCostRequestModalProps] = useState(null);
  const [pendingCostExists, setPendingCostExists] = useState({});

  const selectedEditableTabPanel = useRef("");
  const reportsToShow = useMemo(() => {
    const reportList = reports || [];
    return isDummy ? reportList.filter((report) => report?.is_blocked) : reportList;
  }, [isDummy, reports]);

  // const formatDate = (date) => {
  //   if (!date) return "";
  //   const parsedDate = new Date(date);
  //   const year = parsedDate.getFullYear();
  //   const month = String(parsedDate.getMonth() + 1).padStart(2, "0");
  //   const day = String(parsedDate.getDate()).padStart(2, "0");
  //   return `${month}/${day}/${year}`;
  // };
  const handleGenrateDocument = (instanceId, name) => {
    setInstanceIdForGenrateDoc(instanceId);
    setDropdownName(name);
    setShowDocument(true);
  };

  const refreshPendingCosts = useCallback(async () => {
    const case_id = getCaseId();
    const client_id = getClientId();
    const reportIds = reportsToShow.map((report) => report?.id).filter(Boolean);

    if (!case_id || !client_id || reportIds.length === 0) {
      setPendingCostExists({});
      return;
    }

    const checks = await Promise.all(
      reportIds.map(async (reportId) => ({
        reportId,
        exists: await checkPendingCost({
          case_id,
          client_id,
          source_object: "Reports",
          source_object_id: reportId,
          source_key: "report_number",
        }),
      }))
    );

    setPendingCostExists(
      checks.reduce((acc, { reportId, exists }) => {
        acc[reportId] = exists;
        return acc;
      }, {})
    );
  }, [reportsToShow]);

  useEffect(() => {
    refreshPendingCosts();
  }, [refreshPendingCosts]);

  const showDeleteConfirmPopup = () => {
    setShowDeleteConfirm(true);
    setSelectedReport(null);
  };

  const handleDeleteSubmission = async () => {
    const response = await api_without_cancellation.delete(`/api/report/${forDeleteReportId}/`);
    if (response.status === 204) {
      setShowDeleteConfirm(false);
      fetchReports();
    }
  };

  const buttonData = [
    {
      id: "generate-document-button",
      iconClassName: "ic ic-15 ic-generate-document",
      buttonText: "Letter",
      className: "p-l-6 p-r-5",
      style: { height: "25px" },
      onClick: (id, name) => handleGenrateDocument(id, name),
    },
  ];
  const handleCloseFucton = () => {
    setSelectedReport(null);
  };
  const PHOTO_HEIGHT = 150;
  const defaultThumbnailProps = {
    height: `${PHOTO_HEIGHT}px`,
    width: "255px",
    borderColor: "var(--primary-15)",
  };
  return (
    <>
      {reportsToShow.map((report) => {
        const costRequestExists = !!pendingCostExists[report?.id];
        const EmploymentButtonsConfig2 = [
          {
            id: "generate-document-button",
            imgSrc: costIcon,
            imgClassName: `ic ic-15 m-r-5 ${costRequestExists ? "grayscale" : ""}`,
            buttonText: "Cost Request",
            className: "p-l-6 p-r-5",
            style: { height: "25px", color: costRequestExists ? "grey" : undefined },
            disabled: costRequestExists,
            onHover: () => {},
            onMouseLeave: () => {},
            onClick: () =>
              setCostRequestModalProps({
                source_key: "report_number",
                source_id: report?.id,
                name: report?.reporting_agency_name,
                first_name: report?.contact_first_name,
                middle_name: report?.contact_middle_name,
                last_name: report?.contact_last_name,
                address1: report?.address,
                address2: report?.address1,
                city: report?.city,
                state: report?.state,
                zip_code: report?.zip_code,
                phone_number: report?.phone,
                fax_number: report?.fax,
                ext: report?.extension || "",
                email: report?.email,
                amount: report?.cost,
                cost_name: "Reports Request Cost",
                category_suffix: "Reports Request Cost",
              }),
          },
        ];

        const reportData = [
          {
            label: "Report No",
            value: report?.report_number ? (
              report?.report_number
            ) : (
              <span className="text-primary-50">####</span>
            ),
          },
          { label: "Completed", value: formatCalendarDate(report?.completed) },
          { label: "Cost", value: currencyFormat(report?.cost) },
          { label: "Requested", value: formatCalendarDate(report?.date_ordered) },
          {
            label: "Received",
            value: formatCalendarDate(report?.date_recieved),
          },
        ];

        const title = report?.contact_title?.trim() || "";
        const firstName = report?.contact_first_name?.trim() || "";
        const lastName = report?.contact_last_name?.trim() || "";
        const name = `${title} ${firstName} ${lastName}`.trim();

        const type = report?.report_type_name?.trim()?.toUpperCase() || "";
        return (
          <div key={report?.id} className="expert record-panel">
            <PanelActionBarComponent
              compact
              id={report?.id}
              page_id={14}
              title={report?.contact_title}
              first_name={report?.contact_first_name}
              last_name={report?.contact_last_name}
              name={type}
              type={report?.reporting_agency_name}
              report_type_name={report?.report_type_name}
              report_agency_name={report?.reporting_agency_name}
            />
            <div
              className={`d-flex record-panel-body flex-wrap ${!report?.processed_photo_slots || report.processed_photo_slots.length > 0 ? "record-panel-body--photo" : ""}`}
            >
              <div className="leins-container-four">
                <div className="p-t-5">
                  {report?.processed_photo_slots
                    ? report?.processed_photo_slots?.slice(0, 1)?.map((photoSlot, index) => {
                        if (!photoSlot?.photo) {
                          return (
                            <DefaultThumbnail
                              key={`empty-${index}`}
                              {...defaultThumbnailProps}
                              photoData={photoSlot}
                              photoSlots={report?.processed_photo_slots}
                              refetch={fetchReports}
                              isPanel
                              panelId={report.id}
                              pageName="Reports"
                            />
                          );
                        }
                        return (
                          <PhotoSlot
                            key={photoSlot.photo?.photo_slot.slot_number}
                            photoSlot={photoSlot?.photo}
                            photoSlots={report?.processed_photo_slots}
                            pageName="Reports"
                            isPanel
                            panelId={report.id}
                            slotNumber={photoSlot.photo?.photo_slot.slot_number}
                            refetch={() => fetchReports()}
                            // height="349"
                            // width="255"
                          />
                        );
                      })
                    : Array.from({ length: 1 }).map((_, index) => (
                        <DefaultThumbnail
                          key={`skeleton-${index}`}
                          {...defaultThumbnailProps}
                          photoData={null}
                        />
                      ))}
                </div>
                <div className="min-w-260px-client">
                  <ContactPanelForTreatment
                    id={report?.id}
                    panel_name="Reporting Agency"
                    title={report?.name}
                    name={report?.reporting_agency_name}
                    address1={report?.address}
                    address2={report?.address1}
                    city={report?.city}
                    state={report?.state}
                    zip_code={report?.zip_code}
                    phone_number={report?.phone}
                    email={report?.email}
                    onSelectObject={() => (
                      setSelectedReport(report),
                      (selectedEditableTabPanel.current = "reporting-agency"),
                      setForDeleteReportId(report?.id)
                    )}
                    websiteURL={report?.website}
                    buttonData={buttonData}
                    pageName={"Reports"}
                    className=""
                    genrate_doc_address={9}
                    templateDropdownId={9}
                    templatePageId={14}
                  />
                </div>

                <div className="min-w-260px-client">
                  <ContactPanelForTreatment
                    id={report?.id}
                    panel_name="Report Taken By"
                    className=""
                    pageName={"Reports"}
                    name={name}
                    buttonData={buttonData}
                    onSelectObject={() => (
                      setSelectedReport(report),
                      (selectedEditableTabPanel.current = "report-taken-by"),
                      setForDeleteReportId(report?.id)
                    )}
                    genrate_doc_address={9}
                    templateDropdownId={9}
                    templatePageId={14}
                  />
                </div>
                <div className="min-w-260px-client">
                  <InformationPanel
                    panel_name="Report Information"
                    data={reportData}
                    onSelectReport={() => (
                      setSelectedReport(report),
                      (selectedEditableTabPanel.current = "report-information"),
                      setForDeleteReportId(report?.id)
                    )}
                    defaultLength={5}
                    panelClassName="min-height-auto p-r-5"
                    colorGiven={"var(--primary-25)"}
                    hasBtn={true}
                    buttonData={EmploymentButtonsConfig2}
                  />
                </div>
              </div>

              <div
                className=""
                style={{
                  flex: 1,
                  minHeight: "135px",
                  maxHeight: "auto",
                  paddingRight: "0px",
                  scrollbarWidth: "none",
                  minWidth: "min(330px, 100%)",
                }}
              >
                <p className="menu-bar-style columnsTitle text-center">Notes</p>

                <TreatmentNotesSection
                  entity_type={"Reports"}
                  record_id={report?.id}
                  module={"Reports"}
                  pagePanels={3}
                />
              </div>
            </div>
            <div className=" documents-wrapper m-t-5">
              <div className="col-12">
                {/* <div className="height-25">
                  <h4 className="text-capitalize d-flex align-items-center justify-content-center h-100 text-lg text-upper-case background-main-10 font-weight-semibold text-center client-contact-title">
                    {report?.reporting_agency} {report?.report_type_name}
                    &nbsp;Document Row
                  </h4>
                </div> */}
                <DocumentRow
                  pageName={`${report?.reporting_agency || ""} ${report?.report_type_name || ""} `}
                  clientProvider={report}
                  page_id={14}
                  showSaveToPage={false}
                />
              </div>
            </div>
          </div>
        );
      })}

      {showDocument && (
        <GenrateDocument
          show={true}
          handleClose={() => setShowDocument(false)}
          PageEntity="Reports"
          instanceId={instanceIdForGenrateDoc}
          dropdownName={dropdownName}
        />
      )}

      {selectedReport && (
        <EditReportModal
          show={selectedReport}
          handleClose={handleCloseFucton}
          report={selectedReport}
          onShowDeleteConfirmPopup={showDeleteConfirmPopup}
          activeTab={selectedEditableTabPanel.current}
          onFetchReports={fetchReports}
        />
      )}
      {showDeleteConfirm && (
        <ConfirmDeletePopup
          handleDeleteSubmission={handleDeleteSubmission}
          handleClose={() => setShowDeleteConfirm(false)}
          entity="INCIDENT REPORT"
        />
      )}
      {costRequestModalProps && (
        <CostRequestModal
          show={!!costRequestModalProps}
          onClose={() => {
            setCostRequestModalProps(null);
            refreshPendingCosts();
          }}
          source_model="Reports"
          page_id={14}
          {...costRequestModalProps}
        />
      )}
    </>
  );
};

export default ReportTab;
